import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';

import { BubbleButton } from '@go-client/components/BubbleUI';
import Page from './Page';

import './MaintenanceMode.scss';
import { readQs } from '@go-shared/lib/querystring';
import { getMaintenanceMode } from '@go-client/lib/api/admin';
import { MaintenanceModeOptions } from '@go-shared/types/admin';
import { ROUTES } from '@go-client/routes';

const SERVER_STATE_CHECK_INTERVAL = 1; // In seconds
const DEFAULT_MESSAGE = `The GO Server is currently under maintenance.
Please try again in some time.`;

/**
 * Return either the string value of `redirectFrom` in the QS, or HOME_PATH
 */
function getRedirectionUrl(): string {
  let redirectFrom = readQs().redirectFrom;
  if (!redirectFrom || typeof redirectFrom !== 'string') {
    return ROUTES.HOME_ROUTE();
  }
  return redirectFrom;
}

interface MaintenanceModeRouteState {
  maintenanceMode?: MaintenanceModeOptions;
}

function getInitialMessage(state?: MaintenanceModeRouteState) {
  if (state && state.maintenanceMode && state.maintenanceMode.message) {
    return state.maintenanceMode.message;
  }
  return DEFAULT_MESSAGE;
}

export default function MaintenanceMode(
  props: RouteComponentProps<{}, {}, MaintenanceModeRouteState>
) {
  let redirectFrom = getRedirectionUrl();
  let initialMessage = getInitialMessage(props.location.state);
  let [message, setMessage] = useState(initialMessage);
  useEffect(() => {
    const intervalId = setInterval(async () => {
      let mode = await getMaintenanceMode();
      if (mode) {
        if (!mode.enabled) {
          props.history.push(redirectFrom);
        } else if (mode.message && String(mode.message).trim()) {
          setMessage(mode.message);
        }
      }
    }, SERVER_STATE_CHECK_INTERVAL * 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Page className="MaintenanceModePage">
      <div className="h-full grid items-center justify-center">
        <div className="shadow-xl" style={{ width: '400px' }}>
          <div className="aspect-wide bg-ocean logo"></div>
          <div className="p-8 bg-white">
            <h1 className="text-xl mb-3">Under Maintenance</h1>
            <div className="bg-eggshell border rounded px-4 py-3 mb-5">
              <p className="text-center">{message}</p>
            </div>
            <BubbleButton variant="slate" linkProps={{ to: redirectFrom }}>
              Try again
            </BubbleButton>
          </div>
        </div>
      </div>
    </Page>
  );
}
